import React, { Component, useState, useEffect, useRef } from 'react';
import { Form, Modal, Button, Icon, Header, Input, Message } from 'semantic-ui-react'
import Amplify, { API } from 'aws-amplify';

let apiName = 'apirestcustomers2';
let path = '/customers';


function DeleteItem(value) {
    const [open, setOpen] = React.useState(false)
    const [errorMessage, setErrorMessage] = useState("") 
    const [result, setResult] = useState([])

    useEffect(() => { //TODO check first render
        if (open) {
            console.log("MODAL OPEN") 
        }
        else {
            console.log("MODAL CLOSE")
            setErrorMessage("")
        }
    }
    , [open])

    useEffect(() => {
        if ( Object.hasOwn(result, 'status')) {
            console.log("status", result.status)
        } else {
            setOpen(false)
        }
        }, [result])

    function handleSubmit() {
        console.log("Performing delete for", value)
        API.del(apiName, path + "/" + value.id).then(response => {
            console.log(response)
            setResult(response)
            value.setMessage({msgText: 'Record ' + value.id + ' successfully deleted.', msgType: 'I'})
            }).catch(error => {
                console.log("ERROR", error.response)
                setErrorMessage(error.response.data.message)
                setResult(error.response)
                return;
            });

        return
    }

    return ( 
        <Modal
          as={Form}
          onSubmit={e => handleSubmit(e)}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Icon name = 'trash alternate outline'/>}
        >
          <Header><Icon name='trash alternate outline' color='blue' />Delete Customer</Header>
          <Modal.Content>Do you want to delete the record {value.id} {value.name}?
          <Message  error visible={errorMessage.length>0} >
                      <Icon name='exclamation mark' />{errorMessage}
                  </Message>          
          </Modal.Content>
          
          <Modal.Actions>
            <Button type='button' color='black' onClick={(event) => {
                                                          setOpen(false)
                                                          }}>
              Cancel
            </Button>
            <Button
              content='Delete'
              type='submit'
              labelPosition='right'
              icon='checkmark'    style={{backgroundColor: 'red'  }}      
              positive
            />
           
          </Modal.Actions>
          
        </Modal>
        
      )


}

export default DeleteItem